import { render, staticRenderFns } from "./ProjectCardNew.vue?vue&type=template&id=98457ce8"
import script from "./ProjectCardNew.vue?vue&type=script&lang=ts"
export * from "./ProjectCardNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98457ce8')) {
      api.createRecord('98457ce8', component.options)
    } else {
      api.reload('98457ce8', component.options)
    }
    module.hot.accept("./ProjectCardNew.vue?vue&type=template&id=98457ce8", function () {
      api.rerender('98457ce8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/ProjectCardNew.vue"
export default component.exports